exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.submission-panel .panel-content{height:calc(100vh - 386px)\n}", ""]);

// exports
